export default "__VITE_ASSET__B0teWf4o__"